"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jquery_1 = __importDefault(require("jquery"));
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
jquery_1.default(function () {
    var $headerEl = jquery_1.default('#header');
    var $headerExpanded = jquery_1.default('.main-nav');
    var $headerExpandedSlide = jquery_1.default('.js-header-expanded-slide');
    var headerHeight = $headerEl.outerHeight() || 0;
    jquery_1.default('.overlay, .main-nav').css({ "top": headerHeight + "px" });
    function showMobileMenu() {
        $headerEl.removeClass('close').addClass('open');
        $headerExpandedSlide.removeClass('close').addClass('open');
        jquery_1.default('body').addClass('stop-scrolling');
    }
    function hideMobileMenu() {
        if ($headerEl.hasClass('open')) {
            $headerEl.removeClass('open').addClass('close');
            $headerExpandedSlide.removeClass('open').addClass('close');
        }
        jquery_1.default('body').removeClass('stop-scrolling');
    }
    jquery_1.default('.js-expand-nav, .overlay').on('click', function (e) {
        e.preventDefault();
        if (!$headerExpanded.hasClass('open')) {
            showMobileMenu();
        }
        else {
            hideMobileMenu();
        }
    });
    jquery_1.default('.search-btn button').on('click', function () {
        hideMobileMenu();
        $headerEl.find('.mobile-search').addClass('open');
        $headerEl.find('input[type="text"]').focus();
    });
    jquery_1.default('button.close').on('click', function () {
        $headerEl.find('input[type="text"]').val('');
        $headerEl.find('.mobile-search').removeClass('open');
    });
    jquery_1.default('#secondary-nav ul ul a[href*="#"]').click(function (e) {
        var aid = jquery_1.default(this).attr("href");
        var aidSplit = aid.split("#");
        if (aid.charAt(0) === '#') {
            e.preventDefault();
        }
        jquery_1.default('html,body').animate({ scrollTop: jquery_1.default('#' + aidSplit[1]).offset().top }, 'slow');
    });
    // Scroll automatically to correct div location if a hash is present on url
    if (location.hash && jquery_1.default(location.hash)) {
        jquery_1.default('html,body').animate({ scrollTop: jquery_1.default(location.hash).offset().top }, 'slow');
    }
});
